module.exports = __webpack_public_path__ + "static/img/1000000534.93c83697.jpg";